import { InjectionToken } from '@angular/core';

import { IExportProviderOptions } from './export-provider-options';

/**
 * Injection token for global/lightweight export defaults.
 */
export const EXPORT_OPTIONS = new InjectionToken<IExportProviderOptions>('EXPORT_OPTIONS');
